module.exports = __webpack_public_path__ + "media/images/experiences/sdt-e9888abe6b75904847a56137aa6c29f7.jpg";